import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSelectChange, MatCheckboxChange } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { CountriesService } from '../../shared/services/countries.service';
import { Address } from '../../shared/models/address.model';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
var EditOverviewComponent = /** @class */ (function () {
    function EditOverviewComponent(matDialogRef, data, businessManagerService, countriesService) {
        this.matDialogRef = matDialogRef;
        this.businessManagerService = businessManagerService;
        this.countriesService = countriesService;
        this.isLoading = true;
        this.businessPanelText = 'Expand Business Address Form';
        this.mailingPanelText = 'Expand Mailing Address Form';
        this.businessPanelIsActive = true;
        this.postalCodePlaceHolder = '';
        this.states = new Array();
        this.statesMailing = new Array();
        this.business = data.business; // data object defined in parent;
    }
    EditOverviewComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b, _c, e_2;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        // Defining form controls and validation.
                        if (!this.business.mailingAddress) {
                            this.business.mailingAddress = new Address();
                        }
                        this.formGroup = new FormGroup({
                            title: new FormControl(this.business.name, [Validators.required, Validators.maxLength(50)]),
                            doBusAs: new FormControl(this.business.doBusAs, [Validators.maxLength(50)]),
                            street1: new FormControl(this.business.address.street1, [Validators.required, Validators.maxLength(80)]),
                            street2: new FormControl(this.business.address.street2, [Validators.maxLength(80)]),
                            stateProvince: new FormControl(''),
                            postalCode: new FormControl(this.business.address.postalCode),
                            city: new FormControl(this.business.address.city, [Validators.required, Validators.maxLength(40)]),
                            country: new FormControl('', [Validators.required]),
                            addressSame: new FormControl(false),
                            mailingStreet1: new FormControl(this.business.mailingAddress.street1, [Validators.maxLength(80)]),
                            mailingStreet2: new FormControl(this.business.mailingAddress.street2, [Validators.maxLength(80)]),
                            mailingStateProvince: new FormControl('', [Validators.maxLength(30)]),
                            mailingPostalCode: new FormControl(this.business.mailingAddress.postalCode, [Validators.maxLength(9)]),
                            mailingCity: new FormControl(this.business.mailingAddress.city, Validators.maxLength(40)),
                            mailingCountry: new FormControl(this.business.mailingAddress.country),
                            phone: new FormControl(formatPhoneString(this.business.phone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
                            fax: new FormControl(formatPhoneString(this.business.fax), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
                            webAddress: new FormControl(this.business.webAddress, [Validators.maxLength(100)]),
                            email: new FormControl(this.business.email, [Validators.maxLength(55), this.customEmailValidator]),
                            locationOnField: new FormControl(this.business.locationOnField),
                            isLocatedOnField: new FormControl(true),
                            locationDesc: new FormControl(this.business.locationDesc, [Validators.maxLength(50)])
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getCountries()];
                    case 2:
                        _a.countries = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.business.address.country) return [3 /*break*/, 10];
                        _d.label = 5;
                    case 5:
                        _d.trys.push([5, 9, , 10]);
                        _b = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.business.address.country)];
                    case 6:
                        _b.states = _d.sent();
                        this.states.length ? this.formGroup.controls['stateProvince'].setValidators([Validators.required, Validators.maxLength(50)]) :
                            this.formGroup.controls['stateProvince'].setValidators([Validators.maxLength(30)]);
                        if (!(this.business.mailingAddress && this.business.mailingAddress.country)) return [3 /*break*/, 8];
                        _c = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.business.mailingAddress.country)];
                    case 7:
                        _c.statesMailing = _d.sent();
                        _d.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_2 = _d.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 10];
                    case 10:
                        this.isLoading = false;
                        this.formGroup.patchValue({ country: this.business.address.country || '' });
                        this.formGroup.patchValue({ mailingCountry: this.business.mailingAddress.country || '' });
                        this.formGroup.patchValue({ stateProvince: this.business.address.stateProvince || '' });
                        this.formGroup.patchValue({ mailingStateProvince: this.business.mailingAddress.stateProvince || '' });
                        if (this._compareAddress()) {
                            this.formGroup.patchValue({ addressSame: true });
                            this._changeMailingFieldsState(true);
                        }
                        if (!this.business.locationOnField) {
                            this.formGroup.patchValue({ isLocatedOnField: false, locationOnField: '' });
                        }
                        this._setPostalCodeValidation(this.business.address.country);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditOverviewComponent.prototype.customEmailValidator = function (control) {
        if (!control.value) {
            return null;
        }
        return Validators.email(control);
    };
    /**
     * triggered when value inside countries dropdown changes; event.value contains two digit country code.
     * @param {MatSelectChange} event
     * @return {Promise<void>}
     */
    EditOverviewComponent.prototype.countryChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if value property is empty return
                        if (!event.value) {
                            return [2 /*return*/];
                        }
                        if (!(event.source.id.toString() === '1')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._setAddressForm(event.value)];
                    case 1:
                        _a.sent();
                        if (event.value === this.business.address.country) {
                            this.formGroup.patchValue({ stateProvince: this.business.address.stateProvince || '' });
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(event.source.id.toString() === '2')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._setMailingAddressForm(event.value)];
                    case 3:
                        _a.sent();
                        if (event.value === this.business.mailingAddress.country) {
                            this.formGroup.patchValue({ mailingStateProvince: this.business.mailingAddress.stateProvince || '' });
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *  returns true if {Business} address and mailing address are the same.
     * @return {boolean}
     * @private
     */
    EditOverviewComponent.prototype._compareAddress = function () {
        return (this.business.address.street1 === this.business.mailingAddress.street1 &&
            this.business.address.street2 === this.business.mailingAddress.street2 &&
            this.business.address.city === this.business.mailingAddress.city &&
            this.business.address.stateProvince === this.business.mailingAddress.stateProvince &&
            this.business.address.country === this.business.mailingAddress.country);
    };
    /**
     * Function toggles mailing address fields in UI betweened disabled and enabled based on boolean flag passed in.
     * @param {boolean} disabled
     * @return {Promise<void>}
     * @private
     */
    EditOverviewComponent.prototype._changeMailingFieldsState = function (disabled) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!disabled) return [3 /*break*/, 1];
                        this.statesMailing = this.states;
                        this.formGroup.controls['mailingStreet1'].reset({ value: this.formGroup.controls['street1'].value, disabled: true });
                        this.formGroup.controls['mailingStreet2'].reset({ value: this.formGroup.controls['street2'].value, disabled: true });
                        this.formGroup.controls['mailingStateProvince'].reset({ value: this.formGroup.controls['stateProvince'].value, disabled: true });
                        this.formGroup.controls['mailingPostalCode'].reset({ value: this.formGroup.controls['postalCode'].value, disabled: true });
                        this.formGroup.controls['mailingCity'].reset({ value: this.formGroup.controls['city'].value, disabled: true });
                        this.formGroup.controls['mailingCountry'].reset({ value: this.formGroup.controls['country'].value, disabled: true });
                        return [3 /*break*/, 5];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.business.mailingAddress.country)];
                    case 2:
                        _a.statesMailing = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.controls['mailingStreet1'].reset({ value: this.business.mailingAddress.street1, disabled: false });
                        this.formGroup.controls['mailingStreet2'].reset({ value: this.business.mailingAddress.street2, disabled: false });
                        this.formGroup.controls['mailingStateProvince'].reset({ value: this.business.mailingAddress.stateProvince, disabled: false });
                        this.formGroup.controls['mailingPostalCode'].reset({ value: this.business.mailingAddress.postalCode, disabled: false });
                        this.formGroup.controls['mailingCity'].reset({ value: this.business.mailingAddress.city, disabled: false });
                        this.formGroup.controls['mailingCountry'].reset({ value: this.business.mailingAddress.country, disabled: false });
                        this.formGroup.patchValue({
                            mailingStreet1: this.business.mailingAddress.street1,
                            mailingStreet2: this.business.mailingAddress.street2,
                            mailingStateProvince: this.business.mailingAddress.stateProvince,
                            mailingPostalCode: this.business.mailingAddress.postalCode,
                            mailingCity: this.business.mailingAddress.city,
                            mailingCountry: this.business.mailingAddress.country
                        });
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * called on is same as business address mat checkbox change event.
     * @param {MatCheckboxChange} event
     */
    EditOverviewComponent.prototype.addressSameChange = function (event) {
        this._changeMailingFieldsState(event.source.checked);
    };
    /**
     * changes states dropdown when a different country is chosen.
     * also changes validators depending on whether or states list exists for country
     * @param {string} value
     * @return {Promise<void>}
     * @private
     */
    EditOverviewComponent.prototype._setAddressForm = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(value)];
                    case 2:
                        _a.states = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.patchValue({ stateProvince: '' });
                        this.isLoading = false;
                        if (!this.states.length) {
                            this.formGroup.controls['stateProvince'].setValidators([]);
                        }
                        else {
                            this.formGroup.controls['stateProvince'].setValidators([Validators.required]);
                        }
                        this._setPostalCodeValidation(value);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditOverviewComponent.prototype._setMailingAddressForm = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_5;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(value)];
                    case 2:
                        _a.statesMailing = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.patchValue({ mailingStateProvince: '' });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If countryCode is 'US', Postal Code field becomes required.
     * @param {string} countryCode
     * @private
     */
    EditOverviewComponent.prototype._setPostalCodeValidation = function (countryCode) {
        if (countryCode === 'US') {
            this.postalCodePlaceHolder = 'Zip Code *';
            this.formGroup.controls['postalCode'].setValidators([
                Validators.required,
                Validators.pattern('^\\d{5}$')
            ]);
            this.formGroup.controls['postalCode'].updateValueAndValidity();
        }
        else {
            this.postalCodePlaceHolder = 'Postal Code';
            this.formGroup.controls['postalCode'].setValidators([Validators.maxLength(9)]);
            this.formGroup.controls['postalCode'].updateValueAndValidity();
        }
    };
    EditOverviewComponent.prototype.businessPanelOpened = function () {
        this.businessPanelText = 'Enter Business Address';
        this.businessPanelIsActive = true;
    };
    EditOverviewComponent.prototype.businessPanelClosed = function () {
        this.businessPanelText = 'Expand Business Address Form';
    };
    EditOverviewComponent.prototype.mailingPanelOpened = function () {
        this.mailingPanelText = 'Enter Mailing Address';
        this.businessPanelIsActive = false;
        if (this.formGroup.controls['addressSame'].value) {
            this._changeMailingFieldsState(true);
        }
    };
    EditOverviewComponent.prototype.mailingPanelClosed = function () {
        this.mailingPanelText = 'Expand Mailing Address Form';
    };
    /**
     * formats passed in phone number string;
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    EditOverviewComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    /**
     * event triggered by keyup event on phone number or fax fields
     * @param event
     * @param {string} field
     * @param phoneInputObj
     */
    EditOverviewComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone number or fax field goes out of focus
     * @param {string} field
     */
    EditOverviewComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    /**
     * closes modal
     */
    EditOverviewComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this.matDialogRef.close(result);
        }
    };
    /**
     * submits form values to api server if formGroup.valid property is true
     * @return {Promise<void>}
     */
    EditOverviewComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var HAS_LOCATION, TEMP_BUSINESS, e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        HAS_LOCATION = this.formGroup.value.isLocatedOnField && this.formGroup.value.locationOnField;
                        TEMP_BUSINESS = this.business;
                        if (!this.formGroup.valid) {
                            return [2 /*return*/];
                        }
                        if (this.formGroup.controls['addressSame'].value) {
                            this._changeMailingFieldsState(true);
                        }
                        // form values are mapped to business object before api call.
                        this.business.name = this.formGroup.value.title;
                        this.business.doBusAs = this.formGroup.value.doBusAs;
                        // business address
                        this.business.address.street1 = this.formGroup.value.street1;
                        this.business.address.street2 = this.formGroup.value.street2 || null;
                        this.business.address.stateProvince = this.formGroup.value.stateProvince || null;
                        this.business.address.postalCode = this.formGroup.value.postalCode || null;
                        this.business.address.city = this.formGroup.value.city;
                        this.business.address.country = this.formGroup.value.country || null;
                        // mailing address
                        this.business.mailingAddress.street1 = this.formGroup.getRawValue().mailingStreet1 || null;
                        this.business.mailingAddress.street2 = this.formGroup.getRawValue().mailingStreet2 || null;
                        this.business.mailingAddress.stateProvince = this.formGroup.getRawValue().mailingStateProvince || null;
                        this.business.mailingAddress.postalCode = this.formGroup.getRawValue().mailingPostalCode || null;
                        this.business.mailingAddress.city = this.formGroup.getRawValue().mailingCity || null;
                        this.business.mailingAddress.country = this.formGroup.getRawValue().mailingCountry || null;
                        // contact info & web address
                        this.business.phone = undoPhoneFormat(this.formGroup.value.phone);
                        this.business.fax = undoPhoneFormat(this.formGroup.value.fax);
                        this.business.webAddress = this.formGroup.value.webAddress;
                        this.business.email = this.formGroup.value.email;
                        if (this.formGroup.value.locationDesc) {
                            this.business.locationDesc = this.formGroup.value.locationDesc.trim();
                        }
                        else {
                            this.business.locationDesc = null;
                        }
                        // handles checkbox field isLocatedOnField
                        this.business.locationOnField = HAS_LOCATION ? this.formGroup.value.locationOnField : null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.businessManagerService.updateBusiness(this.business)];
                    case 2:
                        _a.sent();
                        this.close({ cancelBtnClicked: false, success: true });
                        return [3 /*break*/, 4];
                    case 3:
                        e_6 = _a.sent();
                        this.business = TEMP_BUSINESS;
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditOverviewComponent;
}());
export { EditOverviewComponent };
